import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import type { DeliveryMode } from '../../structureDefinitions/storeState';

import { checkoutResetAction } from './checkoutActions';

const slice = createSlice({
    name: 'deliveryTab',
    initialState: null as DeliveryMode | null,
    reducers: {
        set: (state, action: PayloadAction<DeliveryMode | null>) => {
            return action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(checkoutResetAction, () => {
            return null;
        });
    },
});

export const { actions: deliveryTabActions, reducer: deliveryTabReducer } = slice;
